import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SEO from "./SEO";
import { useAppData } from "../context/AppDataContext";

function formatDate(dateStr) {
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return "";
  return String(date.getFullYear());
}

/** Kratki ulomak teksta za karticu (prvih ~120 znakova). */
function excerpt(text, maxLen = 120) {
  if (!text || typeof text !== "string") return "";
  const trimmed = text.replace(/\s+/g, " ").trim();
  if (trimmed.length <= maxLen) return trimmed;
  return trimmed.slice(0, maxLen).trim() + "…";
}

export default function Travelogue() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { travelogues } = useAppData();
  const lng = i18n.language || "hr";
  const base = lng.slice(0, 2);

  return (
    <div className="app">
      <SEO
        title={`${t("nav.travelogue")} - TraveLina`}
        description="Putopisi i iskustva putovanja s TraveLinom. Autentični doživljaji i priče s putovanja u Španjolsku."
        keywords="putopis, iskustva putovanja, Valladolid, TraveLina putopisi"
      />
      <Navbar />
      <main className="travelogue-page">
        <section className="section section-alt" style={{ paddingTop: "6rem" }}>
          <div className="container">
            <header className="section-header" style={{ marginBottom: "3rem" }}>
              <h1>{t("nav.travelogue")}</h1>
            </header>

            <div className="travelogue-list" style={{ display: "grid", gap: "2rem" }}>
              {travelogues.map((travelogue) => {
                const title = travelogue.title[base] || travelogue.title.en;
                const content = travelogue.content[base] || travelogue.content.en;

                return (
                  <article
                    key={travelogue.id}
                    className="travelogue-article travelogue-card"
                    onClick={() => navigate(`/travelogue/${travelogue.key}`)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        navigate(`/travelogue/${travelogue.key}`);
                      }
                    }}
                    style={{
                      cursor: "pointer",
                      borderRadius: "12px",
                      overflow: "hidden",
                      transition: "transform 0.2s ease, box-shadow 0.2s ease",
                    }}
                  >
                    <div
                      className="travelogue-hero travelogue-hero--card"
                      style={{
                        backgroundImage: `url(${travelogue.image})`,
                      }}
                    >
                      <div className="travelogue-hero-gradient" aria-hidden />
                      <h2 className="travelogue-hero-title travelogue-hero-title--card">{title}</h2>
                    </div>
                    <div className="travelogue-card-body">
                      <div className="travelogue-meta travelogue-meta--card">
                        <time>{formatDate(travelogue.date, lng)}</time>
                      </div>
                      <p className="travelogue-card-excerpt">
                        {excerpt(content)}
                      </p>
                      <span className="travelogue-card-read-more">
                        {t("blog.btnReadMore") || "Pročitaj više"} →
                      </span>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

